import { ComponentProps } from "@declarations/props";
import { useThemeStore } from "@stores/theme.store";
import { linkPage } from "@utils/router";
import { FaArrowLeft } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

export const Header: ComponentProps<{
  height?: number;
  classOverlay?: string;
}> = ({ children, classOverlay, height = 310 }) => {
  return (
    <>
      {children ?? <PageTitle />}
      <div
        className={`card header-card ${classOverlay}`}
        style={{ height: `${height}px` }}
      >
        <div className="card-overlay bg-highlight opacity-95"></div>
        <div className="card-overlay dark-mode-tint"></div>
        <div className="card-bg preload-img entered loaded bg-header-footer-default"></div>
      </div>
    </>
  );
};

const PageTitle = () => {
  const navigate = useNavigate();
  const { header } = useThemeStore((state) => state);
  return (
    <div className={`page-title page-title-${header.type ?? "large"}`}>
      <h2 className="greeting-text" style={{ letterSpacing: "2px" }}>
        {header.buttonBack && (
          <span
            onClick={() => navigate(-1)}
            className="tw-p-1 tw-pe-2 tw-cursor-pointer"
          >
            <FaArrowLeft size={20} />
          </span>
        )}
        {header.title ?? <>SIPond</>}
      </h2>
      {/* {header.avatar && (
        <Link
          to={linkPage.HOME_PROFILE}
          replace={true}
          data-menu="menu-main"
          className="bg-fade-highlight-light shadow-xl preload-img bg-image-avatar-default"
        />
      )} */}
    </div>
  );
};
